import React from 'react';
import { Box, Typography, Link } from '@mui/material';

import './index.css';

const Footer: React.FC<any> = () => {
  const WEBSITE_URL = process.env.REACT_APP_WEBSITE_BASE_URL;
  return (
    <Box className="footer-auth--box">
      <Box className="footer-auth--container">
        <Box>
          <Typography component="p" className="footer-auth--text">
            {` Copyright © ${new Date().getFullYear()} HireCoder AI Inc. All Rights Reserved.`}
          </Typography>
        </Box>
        <Box display={'flex'} columnGap={4}>
          <Link
            className="sign-up--term-condition-url-footer-link"
            href={`${WEBSITE_URL}/terms-and-conditions`}>
            {' '}
            Terms and Condition{' '}
          </Link>
          <Link
            className="sign-up--term-condition-url-footer-link"
            href={`${WEBSITE_URL}/terms-and-conditions#privacy-policy`}>
            {' '}
            Privacy Policy{' '}
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
